export const PUBLIC_ACTION_TYPES = {
    GET_COUNTRY_REQUEST: 'GET_COUNTRY_REQUEST',
    GET_COUNTRY_DATA: 'GET_COUNTRY_DATA',
    GET_COUNTRY_ERROR: 'GET_COUNTRY_ERROR',
    GET_COUNTRY_RESET: 'GET_COUNTRY_RESET',

    GET_REGION_REQUEST: 'GET_REGION_REQUEST',
    GET_REGION_DATA: 'GET_REGION_DATA',
    GET_REGION_ERROR: 'GET_REGION_ERROR',
    GET_REGION_RESET: 'GET_REGION_RESET',

    GET_STATE_REQUEST: 'GET_STATE_REQUEST',
    GET_STATE_DATA: 'GET_STATE_DATA',
    GET_STATE_ERROR: 'GET_STATE_ERROR',
    GET_STATE_RESET: 'GET_STATE_RESET',

    GET_CITY_REQUEST: 'GET_CITY_REQUEST',
    GET_CITY_DATA: 'GET_CITY_DATA',
    GET_CITY_ERROR: 'GET_CITY_ERROR',
    GET_CITY_RESET: 'GET_CITY_RESET',

    GET_GOAL_ATTR_REQUEST: 'GET_GOAL_ATTR_REQUEST',
    GET_GOAL_ATTR_DATA: 'GET_GOAL_ATTR_DATA',
    GET_GOAL_ATTR_ERROR: 'GET_GOAL_ATTR_ERROR',
    GET_GOAL_ATTR_RESET: 'GET_GOAL_ATTR_RESET',
}
